export default __webpack_public_path__ + "media/avatars/04-0a09918b.png";